import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { Router } from '@angular/router';
import { LogService } from '../../shared/log/log.service';
import { DropdownSearchComponent } from '../../shared/dropdown-search/dropdown-search.component';
import { DropdownItem } from '../../event/models/dropdown-item';
import { PioneerUtils } from '../../event/utils/pioneer-utils';
import {
  AuthenticationStore,
  ExternalSourceError
} from '../../permission/services/authentication.store';
import { FormControl } from '@angular/forms';
import { UserPermission } from 'app/permission/models/user-permission.model';

@Component({
  selector: 'pioneer-iata-by-default-modal',
  templateUrl: `./iata-by-default-modal.component.html`
})
export class IataByDefaultModalComponent implements OnInit {

  @ViewChild(ModalDirective)
  public iataByDefaultModal: ModalDirective;

  public enableButton = false;
  public agencyControl: FormControl = new FormControl();
  public agencies: DropdownItem[] = [];
  public token: string = null;
  public defaultArcIata: string = null;

  @ViewChild('agencyDropdown')
  public agencyDropdown: DropdownSearchComponent;

  @Input()
  public config = {
    backdrop: 'static',
    keyboard: false
  };

  @Output()
  public closed = new EventEmitter();

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService,
              private router: Router,
              private logService: LogService,
              private authenticationStore: AuthenticationStore) {
  }

  ngOnInit() {
  }

  public open(token: string, multiAgencies: MultiAgency[]): void {
    this.token = token;
    multiAgencies.forEach(agency => {
      const agencyId = PioneerUtils.safeTrim(agency.agencyId);
      const agencyName = PioneerUtils.safeTrim(agency.agencyName);
      this.agencies.push(new DropdownItem(agencyId, agencyName + ' - ' + agencyId));
    });
    this.iataByDefaultModal.show();
  }

  public close(value: boolean): void {
    this.closed.emit(value);
    this.iataByDefaultModal.hide();
  }

  public endSession(): void {
    this.close(false);
  }

  public refreshAuthentication(): void {
    this.authenticationStore.refreshAuthentication().subscribe(() => {
      this.close(true);
    });
  }

  agencySelected(agency: DropdownItem) {
    if (agency) {
      this.enableButton = true;
      this.defaultArcIata = agency.key;
    } else {
      this.enableButton = false;
      this.defaultArcIata = null;
    }
  }

  apply( ) {
    this.authenticationStore.assignDefaultArcIata(this.token, true, this.defaultArcIata).subscribe(
      (userPermission: UserPermission) => {
        this.logService.debug('subscribe handleTokenFromExternalSource');
        this.router.navigate([ '/' ], {replaceUrl: true});
        this.logService.debug(`after navigate['/']`);
      },
      (error: ExternalSourceError) => {
        if (error === ExternalSourceError.TOKEN_EXPIRED) {
          this.router.navigate([ '/external-login-expired' ]);
          this.logService.debug(`after navigate['/external-login-expired']`);
        } else {
          this.router.navigate([ '/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' } ]);
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/iata-by-default-modal/iata-by-default-modal.component.ts